import { h } from "preact";
import { useState, useMemo } from "preact/hooks";
import "unfetch/polyfill";
import ListItem from "../ListItem";
import { vpList, vpLoadMoreSpan } from "./List.css";
var VideoList = function (_a) {
    var _b, _c, _d;
    var data = _a.data, onOpenDetailsHandler = _a.onOpenDetailsHandler, onClickPlayHandler = _a.onClickPlayHandler, setIsModalOpen = _a.setIsModalOpen, isPreview = _a.isPreview;
    var _e = useState(0), currentPage = _e[0], setCurrentPage = _e[1];
    var loadMore = function () {
        setCurrentPage(currentPage + 1);
    };
    var carouselStyles = data.styles;
    var numberOfVideos = (_b = data.content) === null || _b === void 0 ? void 0 : _b.length;
    var maxNumOfRows = (_d = (_c = data.styles) === null || _c === void 0 ? void 0 : _c.numOfCards) !== null && _d !== void 0 ? _d : 10;
    var itemsPerPage = Math.min(numberOfVideos, maxNumOfRows);
    var lastItemToShow = Math.min(numberOfVideos, itemsPerPage * (currentPage + 1));
    var contentToShow = useMemo(function () { return data.content.slice(0, lastItemToShow); }, [lastItemToShow, data]);
    return (h("div", { className: vpList, "data-testid": "list-plugin" },
        contentToShow.map(function (item, idx) { return (h(ListItem, { listItem: item, styles: carouselStyles, key: idx, onClickPlayHandler: onClickPlayHandler, onOpenDetailsHandler: onOpenDetailsHandler, setIsModalOpen: setIsModalOpen, isPreview: isPreview })); }),
        lastItemToShow < numberOfVideos && h("div", { className: vpLoadMoreSpan, onClick: loadMore }, "Load more")));
};
export default VideoList;
